// ==============================|| OVERRIDES - CHECKBOX ||============================== //

import { Theme } from "@mui/material/styles";
import { get } from "lodash";

export default function Checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: get(theme, "palette.secondary.300"),
        },
      },
    },
  };
}
